import React, { useEffect, useState } from "react";

import { Preferences } from '@capacitor/preferences';

import axiosCall from './data/axios';
import { IonSpinner } from "@ionic/react";

interface Props {
    children: React.ReactNode;
  }

export const Context = React.createContext<any>(undefined);

export const AuthProvider: React.FC<Props> = ({children}) => {

    const [authValues, setAuthValues] = React.useState<any>({
        authenticated: false,
        user: null,
        isLoading: true
    });
    
    const [refreshed, setRefreshed ] = useState(false);

    const fetchUser = async () => {

        if(authValues.authenticated == false && authValues.isLoading == true){

            let userData = await axiosCall("/auth/user/me", "get", null, true)
                .then((res: any) => {
                    if(res.status.toString().startsWith('2')) {
                        setAuthValues({
                            authenticated: true,
                            user: res,
                            isLoading: false
                        });
                    } else {
                        setAuthValues({
                            authenticated: false,
                            user: res,
                            isLoading: false
                        });
                    }
                })
                .catch((error: any)=>{
                    if(error.message.includes('401') && !refreshed){
                        setRefreshed(true);
                        refresh();
                    } else {
                        setAuthValues({
                            authenticated: false,
                            user: {},
                            isLoading: false
                        });
                    }
                });
    
        } else {
            setAuthValues({
                authenticated: false,
                user: {},
                isLoading: false
            });
        }
    }

    const [rerender, setRerender] = useState(false);

    useEffect(()=>{

        if (!rerender){
            setRerender(true);
            return;
        }

        fetchUser();
        
    }, [rerender]);

    const refresh = async () => {

        let refreshToken = Preferences.get({ key: 'refreshToken' });

        let result = await refreshToken.then(async function(tokenData){
            await axiosCall('api/token/refresh/', "post", {'refresh': tokenData.value})
            .then((res: any) => {
                Preferences.set({
                    key: 'accessToken',
                    value: res.data.access,
                });
                window.location.reload();
            }).catch((error: any) => {
                setAuthValues({
                    authenticated: false,
                    user: {},
                    isLoading: false
                });
            });
        });

        return result;
    };

    const logout = () => {

        Preferences.remove({ key: 'accessToken' });
    
        Preferences.remove({ key: 'refreshToken' });

        setAuthValues({
            authenticated: false,
            user: {},
            isLoading: false
        });
    
        window.location.reload();
    };

    let state = {
        authValues,
        setAuthValues,
        logout,
        //fetchUser
    };
    
    if(authValues.isLoading)
        return <IonSpinner name="lines-sharp" color="drukre" style={{display: 'flex',  marginLeft: 'auto', marginRight: 'auto', justifyContent:'center', alignItems:'center', height: '100vh'}}></IonSpinner>;

    return <Context.Provider value={state}>{children}</Context.Provider>;
};

export default Context;


